define('plugin/paid-attributes/view/step/AttributeItemView',['require','plugin/product/view/ProductItemView','lib/theme/ThemeSettings'],function (require) {

    var ProductItemView = require('plugin/product/view/ProductItemView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Attribute item view
     *
     * @class AttributeItemView
     */
    return ProductItemView.extend({

        modelEvents: {
            'change': 'safeRender'
        },

        safeRender: function () {
            if (!this.isDestroyed) {
                // WCAG 2.4.7 / Safari VoiceOver: re-rendering replaces the DOM node
                // and leaves VoiceOver on a ghost element ("no action is available").
                // When the checkbox has focus, skip the full re-render and only
                // sync the visual selected state — the browser already updated
                // the checked attribute natively.
                var checkbox = this.$('.sb-add')[0];
                if (checkbox && document.activeElement === checkbox) {
                    this.$el.toggleClass('selected', this.model.get('qty') > 0);
                    return;
                }
                this.render();
            }
        },

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#paid_attribute_step_item_view_list';
            }
            return '#paid_attribute_step_item_view';
        },
        
        serializeData: function () {
            return _.extend({}, ProductItemView.prototype.serializeData.apply(this), {
                hide_duration: this.getOption('hide_duration')
            });
        }

    });

});
